// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1nv-5","info":"Note_info__e-cfl","note":"Note_note__2RH02","actions":"Note_actions__3n24-"};